import styled from 'styled-components'

const ComponentStyled = styled.div`
  .social-box {
    max-width: 600px;
    margin: 0 auto;

    .social-content {
      padding: 24px 68px;
      background-color: ${({ theme }) => theme.colors.secondaries.opacity30};
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .social-title {
        font-family: 'Playfair Display';
        font-weight: 900;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: -0.02em;
        color: ${({ theme }) => theme.colors.black};
        text-align: center;
        margin-bottom: 25px;
      }

      .social-desc {
        text-align: center;
        font-family: 'Cabin';
        font-weight: 400;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 25px;
        color: ${({ theme }) => theme.colors.black};
      }

      .social-items-wrapper {
        border: 2px solid ${({ theme }) => theme.colors.secondaries.opacity100};
        border-radius: 4px;
        max-width: 320px;
        margin: 0 auto;

        .social-item {
          padding: 12px;
          border-bottom: 2px solid ${({ theme }) => theme.colors.secondaries.opacity100};
          cursor: pointer;
          transition: 0.5s ease all;

          &:hover {
            background-color: ${({ theme }) => theme.colors.secondaries.opacity5};
          }

          &:last-child {
            border: 0;
          }

          .social-item-copy {
            display: flex;
            align-items: center;
            font-family: 'Cabin';
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: ${({ theme }) => theme.colors.black};

            span {
              display: inline-block;
              margin-left: 25px;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .social-box {
      .social-content {
        padding: 24px;

        .social-title {
          font-size: 24px;
          line-height: 24px;
        }

        .social-desc {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
`

export default ComponentStyled
